import { RootState } from '@checkout/state';
import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { Persistor } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { MembershipOverlayPopup } from './../components/container';
import { contextCheckoutConfig } from './../config/contextCheckoutConfig';
import { ICheckoutContextConfig } from './../config/contextCheckoutConfig.d';
import { getConfigContextValue } from './../utils/utils';
import ConnectedIntlProvider from './../wrappers/ConnectedIntlProvider';
import ErrorBoundary from './../wrappers/ErrorBoundary';

interface IOwnProps {
  store: Store<RootState>;
  persistor: Persistor;
  checkoutConfig?: Partial<ICheckoutContextConfig>;
  intlData?: IntlProvider.Props;
}

export const CheckoutContextConfig = React.createContext(
  contextCheckoutConfig
);

const MembershipFormsApp: React.SFC<IOwnProps> = ({ store, persistor, checkoutConfig, intlData }) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedIntlProvider {...intlData} >
        <ErrorBoundary>
          <CheckoutContextConfig.Provider value={getConfigContextValue<ICheckoutContextConfig>(contextCheckoutConfig, checkoutConfig)}>
            <MembershipOverlayPopup />
          </CheckoutContextConfig.Provider>
        </ErrorBoundary>
      </ConnectedIntlProvider>
    </PersistGate>
  </Provider>
);

export default MembershipFormsApp;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/apps/MembershipFormsApp.tsx